<template>
  <div class="passenger__content">
    <component
      :is="component"
      :person="person"
      @edit-person="editPerson"
      @end-edit-person="endEditPerson"
      @edit-person-error="editPersonError"
      :documentId="documentId"
    ></component>
  </div>
</template>

<script>
import DisplayPerson from '@/components/person/DisplayPerson.vue'
import EditPerson from '@/components/person/EditPerson.vue'

export default {
  name: 'ClaimPerson',
  props: {
    person: {
      type: Object,
      required: true,
      default () {
        return {}
      }
    },
    documentId: {
      type: String,
      default () {
        return ''
      }
    }
  },
  data () {
    return {
      component: DisplayPerson
    }
  },
  methods: {
    editPerson () {
      this.component = EditPerson
    },
    endEditPerson () {
      this.component = DisplayPerson
    },
    editPersonError () {
      this.component = DisplayPerson
    }
  }
}
</script>
